/**
 * Logo Upload Service
 * Handles logo uploads with fallback for development vs production
 */

/**
 * Upload logo to Vercel Blob (production) or mock upload (development)
 * @param {Object} imageData - The image data to upload
 * @param {string} imageData.base64 - Base64 encoded image
 * @param {string} imageData.filename - Original filename
 * @param {string} imageData.contentType - Content type
 * @returns {Promise<{success: boolean, url?: string, error?: string}>}
 */
export const uploadLogo = async ({ base64, filename, contentType }) => {
  // Use the deployed Vercel API endpoint for uploads
  const apiUrl = process.env.NODE_ENV === 'development' 
    ? 'https://tpci.vercel.app/api/upload-logo'  // Use deployed API in development
    : '/api/upload-logo'; // Use relative path in production
  
  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        image: base64,
        filename: filename,
        contentType: contentType
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();

    return {
      success: true,
      url: data.url, // Return the Vercel Blob URL
      filename: data.filename
    };

  } catch (error) {
    
    // Return error - don't fallback to base64
    return {
      success: false,
      error: `Upload failed: ${error.message}. Please try again or check your network connection.`
    };
  }
};